<template>
  <div class="info container">
    <!-- <h1>单位管理</h1> -->
      <el-input placeholder="请输入关键字快速检索" prefix-icon="el-icon-search" v-model="input" class="input-with-select" clearable @change = "doFilter" size="small">
        <el-select v-model="select" slot="prepend" placeholder="请选择">
          <el-option label="全文检索" value="1"></el-option>
          <el-option label="通知标题" value="2"></el-option>
        </el-select>
      </el-input>

    <el-button id= "add" type="primary" size="medium" round @click = "addinfo" style="float:right;">添加通知</el-button>
    <div style="clear:both;"></div>
      <el-table
        v-loading="loading"
        element-loading-text="加载中"
        stripe
        :data="info.slice((currentPage-1)*pagesize,currentPage*pagesize)"
        style="width: 100%"
        :row-class-name="tableRowClassName">
        <el-table-column
          type="index"
          width="50"
          align="center">
        </el-table-column>
<!--         <el-table-column
        :filters="[
        { text: '公司通知', value: '公司通知' },
        { text: '事故案例', value: '事故案例' },
        { text: '操作规程', value: '操作规程' },
        { text: '专业知识', value: '专业知识' },]"
        :filter-method="filterLx"
          filter-placement="bottom-end"
          prop="lx"
          label="通知分类"
          width="160"
          align="center">
        </el-table-column> -->
        <el-table-column
          prop="name"
          label="通知标题"
          align="center">
        </el-table-column>

        <el-table-column
          :filters="options"
          :filter-method="filterGLLx"
          filter-placement="bottom-end"
          prop="gllxname"
          label="关联类型"
          width="150"
          align="center">
        </el-table-column>

        <el-table-column
          prop="time"
          label="发布时间"
          width="180"
          align="center">
        </el-table-column>

        <el-table-column
        :filters="[{ text: '正常', value: '正常' }, { text: '草稿', value: '草稿' }, { text: '归档', value: '归档' }]"
        :filter-method="filterZt"
          filter-placement="bottom-end"
          prop="zt"
          label="状态"
          width="90"
          align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.zt === '正常' ? 'success' : (scope.row.zt === '草稿' ? 'warning' : 'info')"
              disable-transitions>{{scope.row.zt}}</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="left">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)"></i></el-button>
            </el-tooltip>
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

        <el-pagination
        v-show="pageshow"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>

  </div>
</template>

<script>

  export default {
    computed:{
      info(){
        return (this.dw.length > 0) ? this.dw : this.$store.state.info;
      },
      dw(){
        return this.$store.getters.getInfo(this.input,this.select);
      },
      total(){
        return this.info.length;
      },
      pageshow(){
        return this.total > 0;
      }
    },
    data(){
      return{
        input: '',
        select: "1",
        pagesize:10,
        currentPage:1,//默认开始页面
        loading: true,
            form: {
              id:0,
              name: '',
              text: '',
              // lx:'',
              gllx:[],
              gllxname:'',
              zt:''
            },
        options:[
            { text: '1类 爆炸品', value: '1类 爆炸品' }, 
            { text: '2类1项 易燃气体', value: '2类1项 易燃气体'}, 
            { text: '2类2项 不燃气体', value: '2类2项 不燃气体' },
            { text: '2类3项 有毒气体', value: '2类3项 有毒气体'}, 
            { text: '3类 易燃液体', value: '3类 易燃液体'}, 
            { text: '4类1项 易燃固体', value: '4类1项 易燃固体'}, 
            { text: '4类2项 自燃物品', value: '4类2项 自燃物品'}, 
            { text: '4类3项 遇湿易燃物品', value: '4类3项 遇湿易燃物品'}, 
            { text: '5类1项 氧化剂', value: '5类1项 氧化剂'},
            { text: '5类2项 有机过氧化物', value: '5类2项 有机过氧化物'},
            { text: '6类1项 毒害品', value: '6类1项 毒害品'},
            { text: '6类2项 感染性物品', value: '6类2项 感染性物品'},
            { text: '7类 放射性物品', value: '7类 放射性物品'},
            { text: '8类 腐蚀品', value: '8类 腐蚀品'},
            { text: '9类 杂类', value: '9类 杂类'},
            { text: '危险废物', value: '危险废物'},
            { text: '普通货物运输', value: '普通货物运输'},
            { text: '旅客运输', value: '旅客运输'}
          ],
            formLabelWidth: '120px',
      }
    },
    methods:{
      addinfo(){
        this.$router.push('/addi')
      },
      filterGLLx(value, row) {
        return row.gllx.indexOf(value) > -1;
      },
      filterLx(value, row) {
        return row.lx === value;
      },
      filterZt(value, row) {
        return row.zt === value;
      },
      doFilter(val) {
        if (this.dw.length == 0) this.$message({showClose: true,message: '没有找到包含【'+val+'】的内容',type: 'warning'});
      },
      handleSizeChange(val) {
        this.pagesize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      handleEdit(i,r){
        this.$router.push("/einfo"+r.id);
      },
      handleDelete(i,r){
            this.$confirm('此操作将永久删除该项, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true;
              this.$message({showClose: true,message: '删除中……'});
          var params = new URLSearchParams();
          params.append('token', 'sqgU1wqtfzcZRAniU');
          params.append('admin', this.$store.getters.name);
          params.append('my', this.$store.getters.token);
          params.append('id', r.id);
          this.$ajax.post("/apis/info.php",params).then((ret) => {
                    this.loading = false;
                    if (ret.data == true) {
                      this.$store.commit('delInfo', r);
                      this.$message({showClose: true,type: 'success',message: '删除成功!'});
                    }else this.$notify.error({title: '错误',message: ret.data});
          }).catch(err=>{
              this.$notify.error({title: '错误',message: '网络异常'});
              this.loading = false;
          });
            }).catch(() => {
              this.$message({showClose: true,type: 'info',message: '已取消'});          
            });
      },
      tableRowClassName({row, rowIndex}) {
        return '';
      },
      getInfo(){
        var params = new URLSearchParams();
        params.append('token', 'cqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        this.$ajax.post("/apis/info.php",params).then((ret) => {
                  console.log(ret);
                  this.loading = false;
                  if (ret.data != "token错误" && ret.data != "数据库连接失败") {
                    this.$store.commit('setInfo', ret.data.sort(this.compare));
                  }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            console.log(err);
            this.$notify.error({title: '错误',message: '网络异常'});
            this.loading = false;
        });
      },
      compare(v1, v2){
        if (Number(v1.id) < Number(v2.id)){
          return 1;
        }else if (Number(v1.id) > Number(v2.id)){
          return -1;
        }else{
          return 0;
        }
      }
    },
    created(){
      if (this.dw.length == 0 || this.$store.state.forceFresh) {
        this.getInfo();
        this.$store.state.forceFresh = false;
      }
      else this.loading = false;
    }
  }
</script>

<style scoped>
  .el-pagination{
      display: flex;
      justify-content:center;
      align-items:center;
  }
  .el-select {
    width: 130px;
  }
  .el-input {
    width: 500px;
  }
  .input-with-select .el-input-group__prepend {
    background-color: #fff;
    float: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/Info.vue